module.exports = __webpack_public_path__ + "static/media/k.11018651.svg";